// extracted by mini-css-extract-plugin
export default {"modal-header":"GeneratePayeModal_modal-header__ykFWF","close-icon":"GeneratePayeModal_close-icon__8y562","modal-body":"GeneratePayeModal_modal-body__esDtn"};